import React, { useState, useCallback, useEffect } from 'react';
import { CgLayoutGrid } from 'react-icons/cg';
import { FaEllipsisV, FaTrashAlt } from 'react-icons/fa'; // 3-dot vertical menu icon
import { Snackbar, Alert } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import './workflow.css';
import CustomSwitch from '../../shared/CustomSwitch/CustomSwitch';
import DropdownMenu from './DropdownMenu';
import '../../modules/Home/styles/HomePageStyle.css'; // Import styles first
import { HOMEPAGE_DETAILS } from '../../shared/Images/imageConstants'; // Import constants after styles
import CustomModal from './CustomModal';
import loader_img from './images/Loading_icon.gif';
//const WorkflowItem = ({ title, subtitle, onClick, handleDelete, isActive, toggleActive }) => {

const WorkflowItem = ({
  title,
  created_at,
  updated_at,
  description,
  onClick,
  onDelete,
  wid,
  bgClassName,
  workflow_category,
  workflow_description,
  workflow_icon,
  isactive,
  isSelectedWorkflow,
  nodes,
  edges,
  status,
  wf_image_name,
  wf_image,
}) => {
  const { token, handleLogout } = useAuth();

  const normalizedTitle = workflow_category
    ? workflow_category.toLowerCase().replace(/\s+/g, '-')
    : 'default';
  const details = HOMEPAGE_DETAILS[normalizedTitle] || {
    image: '',
    description: 'No description available',
    className: 'default',
  };
  //console.log(normalizedTitle,details,'details')

  const [isModalOpen, setIsModalOpen] = useState(false);
  // Snackbar state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [isLoading, setIsLoading] = useState('');

  const openRestrictModal = () => setIsModalOpen(true);
  const closeRestrictModal = () => setIsModalOpen(false);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = (e) => {
    e.stopPropagation(); // Prevent triggering the parent `onClick` event
    setMenuOpen(!menuOpen);
  };

  const [showConfirmation, setShowConfirmation] = useState(false);
  const handleDelete = (e) => {
    e?.stopPropagation(); // Prevent triggering the parent `onClick` event
    isSelectedWorkflow ? openRestrictModal() : setShowConfirmation(true);

    //onDelete(); // Trigger the delete action passed from Home.js
  };

  const confirmDelete = (e) => {
    e.stopPropagation();
    onDelete(); // Trigger the delete action passed from Home.js

    setShowConfirmation(false); // Hide the confirmation block
  };

  const cancelDelete = (e) => {
    e.stopPropagation();
    setShowConfirmation(false); // Hide the confirmation block
  };

  const disabled_wfb = ''; //'Multi-Dwelling Unit Sign Up';

  //const [isActive, setIsActive] = useState((disabled_wfb === title) ? false : true);
  const [isActive, setIsActive] = useState(
    isactive === 'INACTIVE' ? false : true
  );

  /*const toggleChange = (e) => {
      e.stopPropagation(); 
      //console.log(title);
      if(disabled_wfb===title){
        setIsActive(false);
      }else{
        setIsActive(!isActive); 
      }
    };*/

  // validate on activate
  const hasDuplicateTypes = (nodes) => {
    const typeCounts = nodes.reduce((acc, node) => {
      acc[node.type] = (acc[node.type] || 0) + 1;
      return acc;
    }, {});
    return Object.values(typeCounts).some((count) => count > 1);
  };
  // Save workflow functionality (handles both new and existing workflows)
  const validateGraph = (nodes, edges) => {
    const nodeIds = new Set(nodes.map((node) => node.id)); // All available node IDs
    const connectedNodes = new Set(); // Track connected nodes
    const edgeMap = new Map(); // Track duplicate edges
    const sourceCount = new Map(); // Count occurrences of each source
    const targetCount = new Map(); // Count occurrences of each target

    for (const edge of edges) {
      const { source, target } = edge;

      // ✅ 1. Ensure both source and target exist in the node list
      if (!nodeIds.has(source) || !nodeIds.has(target)) {
        setSnackbarMessage(
          `❌ Invalid edge: Source or Target widget is missing.`
        );
        return false;
      }

      // ✅ 2. Ensure each edge is unique (no duplicate connections)
      const edgeKey = `${source}->${target}`;
      if (edgeMap.has(edgeKey)) {
        setSnackbarMessage(`❌ Duplicate edge found!`);
        return false;
      }
      edgeMap.set(edgeKey, true);

      // ✅ 3. Track source and target node connections
      connectedNodes.add(source);
      connectedNodes.add(target);

      // ✅ 4. Check if a source node has multiple outgoing edges
      sourceCount.set(source, (sourceCount.get(source) || 0) + 1);
      if (sourceCount.get(source) > 1) {
        setSnackbarMessage(`❌ A widget has multiple outgoing edges!`);
        return false;
      }

      // ✅ 5. Check if a target node has multiple incoming edges
      targetCount.set(target, (targetCount.get(target) || 0) + 1);
      if (targetCount.get(target) > 1) {
        setSnackbarMessage(`❌ A widget has multiple incoming edges!`);
        return false;
      }
    }

    // ✅ 6. Ensure all nodes are connected by at least one edge
    for (const node of nodes) {
      if (!connectedNodes.has(node.id)) {
        setSnackbarMessage(`❌ Disconnected widget found: ${node.data.label}`);
        return false;
      }
    }
    // console.log("✅ Validation Passed: All nodes are correctly connected, and edges are valid.");
    return true;
  };

  const validateNodeSequence = (edges) => {
    const rules = [
      ['checkForServiceNode', 'chooseProductsNode'],
      ['chooseProductsNode', 'reviewCartNode'],
      ['reviewCartNode', 'paymentNode'],
      ['paymentNode', 'accountSetupNode'],
    ];
    const rules2 = [['accountSetupNode', 'orderReceiptNode']];
    // Map node IDs to their types
    const nodeMap = nodes.reduce((acc, node, key) => {
      acc[node.id] = node.type;
      return acc;
    }, {});

    // const nodeTitle = nodes.reduce((acc, node) => {
    //   acc[node.type] = node.data.label;
    //   return acc;
    // }, {});

    const nodeTitle = {
      checkForServiceNode: 'Check For Service Widget',
      chooseProductsNode: 'Choose Products Widget',
      paymentNode: 'Payment for the products subscriber selected',
      reviewCartNode: 'Review Cart Widget',
      accountSetupNode: 'Account Setup Widget',
      orderReceiptNode: 'Order Receipt Widget',
    };
    // Get the sequence of nodes based on edges
    // const nodeSequence = [];
    // const visited = new Set();

    const adjacencyList = {};
    const inDegree = {}; // Track incoming edges (dependencies)

    // Initialize structures
    Object.keys(nodeMap).forEach((nodeId) => {
      adjacencyList[nodeId] = []; // Empty list for each node
      inDegree[nodeId] = 0; // Initially, no dependencies
    });
    // Fill adjacency list and track dependencies
    edges.forEach(({ source, target }) => {
      adjacencyList[source].push(target);
      inDegree[target] = (inDegree[target] || 0) + 1;
    });

    // Find nodes with no dependencies (inDegree = 0)
    const queue = Object.keys(inDegree).filter(
      (nodeId) => inDegree[nodeId] === 0
    );
    const nodeSequence = [];

    // Process nodes in dependency order (Topological Sorting)
    while (queue.length > 0) {
      const nodeId = queue.shift(); // Take the next node with no dependencies
      nodeSequence.push(nodeMap[nodeId]); // Add to the result sequence

      // Reduce dependencies for connected nodes
      adjacencyList[nodeId].forEach((dependentNode) => {
        inDegree[dependentNode] -= 1;
        if (inDegree[dependentNode] === 0) {
          queue.push(dependentNode);
        }
      });
    }

    // Validate the sequence based on rules
    for (let [requiredNode, dependentNode] of rules) {
      const requiredIndex = nodeSequence.indexOf(requiredNode);
      const dependentIndex = nodeSequence.indexOf(dependentNode);

      // If dependent node exists, required node must come before it
      if (dependentIndex !== -1) {
        if (requiredIndex === -1 || requiredIndex > dependentIndex) {
          // console.log(requiredIndex, dependentIndex);
          setSnackbarMessage(
            `Node dependency rule violated: ${nodeTitle[requiredNode]} must appear before ${nodeTitle[dependentNode]}`
          );
          return false; // Invalid dependency
        }
      }
    }

    for (let [requiredNode, dependentNode] of rules2) {
      const requiredIndex = nodeSequence.indexOf(requiredNode);
      const dependentIndex = nodeSequence.indexOf(dependentNode);

      console.log(requiredIndex, dependentIndex);
      // If dependent node exists, required node must come before it
      if (dependentIndex !== -1) {
        if (requiredIndex === -1 || requiredIndex != dependentIndex + 1) {
          // console.log(requiredIndex, dependentIndex);
          setSnackbarMessage(
            `Node dependency rule violated: ${nodeTitle[requiredNode]} must appear after ${nodeTitle[dependentNode]}`
          );
          return false; // Invalid dependency
        }
      }
    }

    return true; // Sequence is valid
  };

  const validateWorkflow = () => {
    setSnackbarSeverity('error');
    setSnackbarOpen(true);
    if (hasDuplicateTypes(nodes)) {
      setSnackbarMessage("Widgets shouldn't be repeated");
      return;
    } /*else if(nodes.length > 1 && edges.length != (nodes.length - 1)){
        console.log(edges.length, (nodes.length - 1));
        setSnackbarMessage('Please connect the widgets');
        return;
      }*/ else if (nodes.length > 1 && !validateGraph(nodes, edges)) {
      return;
    } else if (!validateNodeSequence(edges)) {
      return;
    }
    return true;
  };

  const isPublishedWorkflow = () => {
    if (status != 'publish') {
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
      setSnackbarMessage('Workflow must be published');
      return;
    }
    return true;
  };

  const toggleChange = useCallback(
    async (e) => {
      e.stopPropagation();
      // Determine new status
      const newStatus = isActive ? 'INACTIVE' : 'ACTIVE';
      if (!isActive) {
        if (!isPublishedWorkflow()) {
          return;
        }
      }

      // Prepare API request payload
      const updatedWorkflow = {
        workflow_status: newStatus,
        workflow_name: title,
      };
      let workflowId = wid;

      try {
        const method = 'PUT'; // isNewWorkflow ? 'POST' :
        const url = `${process.env.REACT_APP_BASE_URL}/workflows/update/${workflowId}`;

        const response = await fetch(url, {
          method,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`, // Bearer token assumed
          },
          body: JSON.stringify(updatedWorkflow),
        });

        if (!response.ok) {
          throw new Error(`HTTP Error: ${response.status}`);
        }

        const data = await response.json();

        if (response.status === 200) {
          setIsActive(!isActive); // Update toggle state
          setSnackbarSeverity('success');
          setSnackbarMessage(`Workflow updated successfully!`);
          // setWorkflowData(data.workflow);
        } else if (data.error) {
          setSnackbarMessage(data.error);
          setSnackbarSeverity('error');
        }
      } catch (error) {
        console.error('API Call Failed:', error);
        setSnackbarMessage('Failed to save workflow.');
        setSnackbarSeverity('error');
      } finally {
        setSnackbarOpen(true);
      }
    },
    [isActive, wid, token]
  );

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short' };
    return date.toLocaleDateString('en-US', options).replace(',', '');
  };
  const timeAgo = (dateString) => {
    const now = new Date();
    const pastDate = new Date(dateString);
    const seconds = Math.floor((now - pastDate) / 1000);

    let interval = Math.floor(seconds / 31536000); // years
    if (interval > 1) return `${interval} years ago`;
    if (interval === 1) return `${interval} year ago`;

    interval = Math.floor(seconds / 2592000); // months
    if (interval > 1) return `${interval} months ago`;
    if (interval === 1) return `${interval} month ago`;

    interval = Math.floor(seconds / 604800); // weeks
    if (interval > 1) return `${interval} weeks ago`;
    if (interval === 1) return `${interval} week ago`;

    interval = Math.floor(seconds / 86400); // days
    if (interval > 1) return `${interval} days ago`;
    if (interval === 1) return `${interval} day ago`;

    interval = Math.floor(seconds / 3600); // hours
    if (interval > 1) return `${interval} hours ago`;
    if (interval === 1) return `${interval} hour ago`;

    interval = Math.floor(seconds / 60); // minutes
    if (interval > 1) return `${interval} minutes ago`;
    if (interval === 1) return `${interval} minute ago`;

    //if (seconds >= 5) return `${seconds} seconds ago`;

    return 'just now';
  };

  const handleSwitch = (e) => {
    e.stopPropagation();
    isSelectedWorkflow ? openRestrictModal() : toggleChange(e);
  };

  const handleClick = (e) => {
    e.stopPropagation();
    isSelectedWorkflow ? openRestrictModal() : onClick(e);
  };

  // const loader_img = './images/Loading_icon.gif';
  return (
    <div
      onClick={title !== disabled_wfb ? handleClick : undefined}
      className={`workflow-item ${details.className}`}
    >
      <div
        className={`bgColor ${isActive ? 'active' : 'disabled'} ${isActive && bgClassName}`}
      ></div>
      {/* <div onClick={toggleChange} className='custom-switch' >
          {isActive ? 'Active' : 'Deactivated'}
          <CustomSwitch checked={isActive} onChange={()=>{}} />
        </div> */}
      <div className="workflow-item-inner-container">
        <div
          style={{ display: 'none' }}
          onClick={title !== disabled_wfb ? handleDelete : undefined}
          className="delete-icon"
        >
          <FaTrashAlt color="#f50000" />
        </div>

        <div>
          <div className="workflow-title">
            {title.length > 30 ? `${title.substring(0, 30)}` : title}
          </div>

          <div
            className="time"
            style={{
              maxWidth: '30rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {description.length > 100
              ? `${description.substring(0, 100)}`
              : description}
          </div>
        </div>

        <div>
          <div>
            {/* <img src={wf_image || details.image} alt="Workflow Icon" style={{ Width: '100%',marginTop:'10px',marginBottom:'10px' }}/> */}
            {(() => {
              let new_img;
              if (wf_image_name) {
                new_img = wf_image;
              } else {
                new_img = details.image;
              }

              return (
                <img
                  src={new_img || loader_img}
                  alt="Workflow Icon"
                  style={{
                    width: '100%',
                    marginTop: '10px',
                    marginBottom: '10px',
                  }}
                />
              );
            })()}
          </div>
        </div>
        <div style={{ position: 'relative' }}>
          <div className="icon-wrap">
            <div className="icon-style">
              <img src="./images/workflow/wf-icon.svg" />
            </div>
          </div>
          <div onClick={handleSwitch} className="custom-switch">
            {isActive ? 'Active' : 'Deactivated'}
            <CustomSwitch checked={isActive} onChange={() => {}} />
          </div>
          <div className="time">
            Created {formatDate(created_at)} <br></br> Last updated{' '}
            {timeAgo(updated_at)}{' '}
          </div>

          <DropdownMenu
            handleDelete={handleDelete}
            isDeletable={title !== disabled_wfb}
          />
        </div>

        {showConfirmation && (
          <div className="delete-modal">
            <div className="bg-overlay"></div>
            <div
              className="delete-block delete-whiteBox"
              style={{
                // position: 'absolute',
                // top: '50%',
                // left: 'auto',
                // right: '5px',
                // transform: 'translate(0, -50%)',
                backgroundColor: 'white',
                padding: '15px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.5)',
                borderRadius: '8px',
                zIndex: 1000,
              }}
            >
              <p>Are you sure you want to delete this item?</p>
              <button
                onClick={confirmDelete}
                style={{
                  backgroundColor: '#dc3545',
                  color: '#fff',
                  border: 'none',
                  padding: '3px 12px',
                  borderRadius: '3px',
                  cursor: 'pointer',
                  marginRight: '10px',
                  fontWeight: 'bold',
                  transition: 'background-color 0.3s ease',
                }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = '#c82333')
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = '#dc3545')}
              >
                Yes
              </button>
              <button
                onClick={cancelDelete}
                style={{
                  backgroundColor: '#6c757d',
                  color: '#fff',
                  border: 'none',
                  padding: '3px 12px',
                  borderRadius: '3px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                  transition: 'background-color 0.3s ease',
                }}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = '#5a6268')
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = '#6c757d')}
              >
                No
              </button>
            </div>
          </div>
        )}

        {/* 3-dot vertical menu */}
        {/* <div 
              onClick={handleMenuToggle} 
              style={{ cursor: 'pointer', color: 'grey' }}>
              <FaEllipsisV />
            </div> */}
      </div>

      {/* Dropdown menu */}
      {menuOpen && (
        <div
          style={{
            position: 'absolute',
            top: '40px', // Adjusted for new layout
            right: '10px',
            border: '1px solid #ddd',
            backgroundColor: '#fff',
            borderRadius: '4px',
            zIndex: 100,
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
          }}
          onClick={(e) => e.stopPropagation()} // Prevents closing dropdown when clicked
        >
          <div onClick={onClick} style={{ padding: '8px', cursor: 'pointer' }}>
            Open
          </div>
          <div
            onClick={handleDelete}
            style={{ padding: '8px', cursor: 'pointer', color: 'red' }}
          >
            Delete
          </div>
        </div>
      )}
      <CustomModal isOpen={isModalOpen} onClose={closeRestrictModal} />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default WorkflowItem;

// const WorkflowItem = ({ title, created_at, updated_at, description, onClick, onDelete, wid  }) =>
